export const iconFontAwesomeTravelHotelJetFighterUp = (
	<i className="fa-solid fa-jet-fighter-up"></i>
);
